import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Tooltip } from "@mui/material";
import { useState } from "react";
// import ScheduledPostActionPopup from "./PostGridActionPopup.component";
import { DoneAll, HighlightOff } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import ConfirmationDialog from "src/components/ConfirmationDialog";
import HttpServices from "src/services/httpService";
import { postsModuleURL, userModuleURL,imageModeuleUrl } from "src/services/urlService";
import { useToaster } from "src/utils/toaster/toasterContext";
import { useNavigate } from 'react-router-dom';
import { CommonHelper } from "src/utils/commonHelper";
import GeneratedPostPendingApprovalGridActionPopup from './generated-post-pending-approval-grid-action-popup.component';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useTranslation } from 'react-i18next';

const GeneratedPostPendingApprovalGridAction = ({ approvePost,handleOpenScheduledPost, handleReCallPendingApprovalPost }) => {
    const { t: translate } = useTranslation();
    const theme = useTheme()
    const navigate = useNavigate();
    const { showToast } = useToaster();
    const [selectedPopoverPost, setSelectedPopoverPost] = useState(null);
    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [loading, setLoading] = useState(false);
    const [confirmationDialogue, setConfirmationDialogue] = useState(null);

    const handleOpenMenu = (event, post) => {
        setSelectedPopoverPost(post);
        setPopoverAnchor(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setSelectedPopoverPost(null);
        setPopoverAnchor(null);
    };

    const closeConfirmationDialogue = () => {
        setConfirmationDialogue(null)
    };

    const failureCallback = (message) => {
        message && showToast(message, 'e');
        handleCloseMenu();
        closeConfirmationDialogue()
        setLoading(false);
    };

    const fetchMediaMetaData = (data, editAsNew = false) => {
        let mediaBody = {
            media_urls: data?.media_url.split(",")
        };
        let postProps = {
            url: imageModeuleUrl.fetchMediaMetadata,
            body: mediaBody,
            successCallback: (imageData, message) => { fetchMediaSuccessCallback(imageData, message, data, editAsNew) },
            failureCallback: failureCallback
        }
        HttpServices.Post(postProps);
    }
    const fetchMediaSuccessCallback = (imageData, mesaage, data, editAsNew) => {
        if (editAsNew) {
            uploadEditDataToNewPost(data, imageData ? imageData.media_datas : []);
        }
        else {
            uploadDataToPost(data, imageData ? imageData.media_datas : []);
        }

    }
    const newPostSucessCallback = (data) => {
        if (data.media_url && data.media_url.length > 0)
            fetchMediaMetaData(data);
        else
            uploadDataToPost(data);
    }

    const editNewPostSucessCallback = (data) => {
        let editAsNew = true
        if (data.media_url && data.media_url.length > 0)
            fetchMediaMetaData(data, editAsNew);
        else
            uploadEditDataToNewPost(data);
    }

    const uploadDataToPost = (data, imageData = []) => {
        setLoading(false);
        const updatedData = {
            ...data,
            media_data: imageData,
            schedule_id: approvePost?.id
        };
        const newPostData = CommonHelper.CommonNewPostAddMediaAllService(updatedData, imageData)
        navigate('/new-post', { state: { data: newPostData } });
    }
    const uploadEditDataToNewPost = (data, imageData = []) => {
        setLoading(false);
        const newPostData = CommonHelper.CommonNewPostAddMediaAllService(data, imageData)
        navigate('/new-post', { state: { data: newPostData } });
    }
    const handleEditPost = () => {
        setLoading(true);
        CommonHelper.SetIsOrgLevelEvent(false);
        CommonHelper.CommonNewPostStruct(false,approvePost.id, newPostSucessCallback, failureCallback)
    };
    const handleEditAsNewPost = () => {
        setLoading(true);
        CommonHelper.SetIsOrgLevelEvent(false);
        CommonHelper.CommonNewPostStruct(false,approvePost.id, editNewPostSucessCallback, failureCallback)
    };

    const handleApprovePost = () => {
        handleCloseMenu()
        setConfirmationDialogue({
            isOpen: true,
            title: translate('generated_post_pending_approval_grid.confirm_post_now', 'Confirm Post Now'),
            message: translate('generated_post_pending_approval_grid.approve_generated_post_message', 'Are you sure you want to Approve this Generated Post?'),
            submitFunction: confirmApprovePost
        })
    };

    const confirmApprovePost = () => {
        setLoading(true); 
        let props = {
            schedule_ids: [approvePost.id],
        };
        let postProps = {
            url: userModuleURL.approveGeneratedPost,
            body: props,
            successCallback: approvePostSuccessCallback,
            failureCallback,
        };
        HttpServices.Post(postProps);
    };

    const approvePostSuccessCallback = (data, message) => {
        message && showToast(message);
        setLoading(false);
        handleCloseMenu();
        closeConfirmationDialogue()
        handleReCallPendingApprovalPost();
    };


    const handleDeletePost = () => {
        handleCloseMenu()
        setConfirmationDialogue({
            isOpen: true,
            title: translate('generated_post_pending_approval_grid.confirm_deletion', 'Confirm Deletion'),
            message: translate('generated_post_pending_approval_grid.delete_schedule_message', 'Are you sure you want to delete this Schedule?'),
            submitFunction: confirmDeletePost
        })
    };

    const confirmDeletePost = () => {
        let postProps = {
            url: postsModuleURL.deleteSchedule + approvePost.id,
            successCallback: deleteSuccessCallback,
            failureCallback,
        };
        HttpServices.Post(postProps);
        closeConfirmationDialogue()
    };


    const deleteSuccessCallback = (data, message) => {
        message && showToast(message);
        handleCloseMenu();
        closeConfirmationDialogue()
        handleReCallPendingApprovalPost();
    };


    const handleSaveAsDraft = () => {
        let props = {
            schedule_post_id: approvePost.id,
        };
        let postProps = {
            url: postsModuleURL.savePostAsDraft,
            body: props,
            successCallback: saveAsDraftSuccessCallback,
            failureCallback,
        };
        HttpServices.Post(postProps);
    };

    const saveAsDraftSuccessCallback = (data, message) => {
        message && showToast(message);
        handleCloseMenu();
    };

    const handlePreview = (e, row) => {
        handleOpenScheduledPost(row.id, true);
    };

    const postActionProps = {
        popoverElement: popoverAnchor,
        approvePostDetails: approvePost,
        handleCloseMenu,
        approvePost: handleApprovePost,
        editAsNewPost: handleEditAsNewPost,
        editPost: handleEditPost,
        saveAsDraft: handleSaveAsDraft,
        deletePost: handleDeletePost,
        loading,
        selectedPopOverPost: selectedPopoverPost,
    };



    return (
        <>
            <Box align='center'>
                {approvePost.has_approve_access &&<Tooltip title={translate('generated_post_pending_approval_grid.approve_post', 'Approve Post')}>
                    <IconButton
                        size="large"
                        color="inherit"
                        sx={{
                            padding: '2px',
                            marginRight: '2px',
                            color: theme.palette.primary.main
                        }}
                        onClick={(e) => {
                            handleApprovePost(e, approvePost);
                        }}
                    >
                        <DoneAll />
                    </IconButton>
                </Tooltip>}
                <Tooltip title={translate('generated_post_pending_approval_grid.preview', 'Preview')}>
                    <IconButton
                        size="large"
                        color="inherit"
                        sx={{ padding: '2px', marginRight: '2px', color: theme.palette.info.main }}
                         onClick={(e) => {
                            handlePreview(e, approvePost)
                        }}
                    >
                        <VisibilityIcon />
                    </IconButton>
                </Tooltip>
                <IconButton
                    size="large"
                    color="inherit"
                    onClick={(e) => {
                        handleOpenMenu(e, approvePost);
                    }}
                    sx={{ padding: '6px', marginRight: '2px' }}
                >
                    <MoreVertIcon />
                </IconButton>
            </Box>
            <GeneratedPostPendingApprovalGridActionPopup  {...postActionProps} />
            {confirmationDialogue && <ConfirmationDialog
                open={confirmationDialogue.isOpen}
                onClose={() => closeConfirmationDialogue()}
                onConfirm={confirmationDialogue.submitFunction}
                title={confirmationDialogue.title}
                message={confirmationDialogue.message}
                loading={loading}
            />}
        </>
    )

}

export default GeneratedPostPendingApprovalGridAction;